import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-todo-priority-field', {
  mixins: [eventListenerMixin],

  properties: {
    priority: {
      type: String,
      default: 'normal',
    },
  },

  connected() {
    this.select = this.querySelector('tr-combo-select-field');

    this.listenTo(this.select, {
      'tr-combo-select-field:change': (event) => {
        event.stopPropagation();
        this.priority = event.detail;
        this.namespacedTrigger('change', {
          detail: event.detail,
          bubbles: true,
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
  },
});
